import styled from "styled-components";

export const GermanyRealityCheckDialogFieldValueBox = styled.div`
    color: ${props => props.theme.colors.brandPrimary};
    align-self: flex-end;
    justify-self: flex-end;
    ${props => props.theme.font.presets.bold}
`